<template>
    <div class="border rounded" v-if="image">
        <div class="bg-gray-300 p-2">
            <button-white @click="type = 'rectangle'" class="mr-4">
                <i class="fa fa-square-o"></i>
            </button-white>
            <button-white @click="type = 'circle'">
                <i class="fa fa-circle-o"></i>
            </button-white>
            <button-white v-show="type === 'rectangle'" @click="rotateLeft" class="mr-4" :class="{'border-blue-500': type === 'rectangle'}">
                <i class="fa fa-undo"></i>
            </button-white>
            <button-white v-show="type === 'rectangle'" @click="rotateRight" :class="{'border-blue-500': type === 'rectangle'}">
                <i class="fa fa-repeat" ></i>
            </button-white>

            <div v-show="type === 'rectangle'">
                <input-text v-model="width">
                    Breite
                </input-text>

                <input-text v-model="height">
                    Höhe
                </input-text>
            </div>

            <div v-show="type === 'circle'">
                <input-text v-model="radius">
                    Radius
                </input-text>
            </div>

        </div>

        <div id="conference_room" style="width:600px;height:400px;" class="p-2"></div>
    </div>
</template>

<script>
import L from "leaflet";
import Card from "../UI/Card";
import ButtonPrimary from "../UI/ButtonPrimary";
import SelectMenu from "../UI/SelectMenu";
import InputText from "../UI/InputText";
import ButtonWhite from "../UI/ButtonWhite";

export default {
    name: "ConferenceRoomPositionEdit",
    components: {
        ButtonWhite,
        InputText,
        SelectMenu,
        ButtonPrimary,
        Card},

    props: ['value'],

    data: (vm) => ({
        height: vm.value.position ? vm.value.position.height : 10,
        width: vm.value.position ? vm.value.position.width : 10,
        radius: vm.value.position ? vm.value.position.radius : 10,
        type: vm.value.position ? vm.value.position.type : 'rectangle',
        center: vm.value.position ? vm.value.position.center : [0, 0],
        angle: vm.value.position ? vm.value.position.angle : 0,
        selectedId: null,
        map: null,
        rectangle: null,
        conferenceRooms: [],
    }),

    watch: {
        height() {
            this.updatePosition(this.center);
        },
        width() {
            this.updatePosition(this.center);
        },
        type() {
            this.updatePosition(this.center);
        },
        radius() {
            this.updatePosition(this.center);
        },
    },

    computed: {
        item: {
            get() {
                return this.value;
            },
            set(value) {
                return this.$emit('input', value);
            },
        },
        image() {
            return this.item.floor?.map_link ?? null;
        },
    },

    mounted() {
        if (!this.image) {
          return;
        }

        if (this.map != null) {
          this.map.remove();
          this.map = null;
        }

        let img = new Image();

        img.onload = () => {
            let minZoom = - Math.ceil( Math.max(img.width + img.height) / 1000 );

            this.map = L.map('conference_room', {
                crs: L.CRS.Simple,
                minZoom: minZoom,
                maxZoom: 2,
            });

            this.createMap(img.width, img.height)

            this.loadFloor();
        }

        img.src = this.image;
    },

    methods: {
        loadFloor() {
            window.axios
                .get(`/admin/floors/${this.item.floor_id}`)
                .then(result => {
                    this.conferenceRooms = result.data.data.conference_rooms.filter(cr => {
                        return cr.position && cr.position.center[0];
                    });
                    this.paintConferenceRooms();
                    this.setZoom();
                });
        },
        paintConferenceRooms() {
            this.conferenceRooms
                .filter(bookable => bookable.id !== this.item.id)
                .forEach(item => {
                    if (!item.position) {
                        return;
                    }
                    if (item.position.type === 'circle') {
                        L.circle(item.position.center, {color: "blue", radius: item.position.radius, weight: 1})
                            .addTo(this.map);

                        return;
                    }

                    let rectangle = L.rectangle([
                        [item.position.center[0] + item.position.height, item.position.center[1] - item.position.width],
                        [item.position.center[0] - item.position.height, item.position.center[1] + item.position.width],
                    ], {color: "blue", weight: 1})
                        .addTo(this.map);

                    this.rotateRectangle(item, rectangle);
                });
        },
        setZoom() {
            //determine desk most left, top, right and bottom value!
            if (this.conferenceRooms.length === 0) {
                return; // TODO set ZOOM to all of the map!
            }

            let [l, t] = this.conferenceRooms[0].position.center;
            let [r, b] = this.conferenceRooms[0].position.center;

            this.conferenceRooms.forEach(desk => {
                l = Math.min(l, desk.position.center[0]);
                b = Math.min(b, desk.position.center[1]);
                r = Math.max(r, desk.position.center[0]);
                t = Math.max(t, desk.position.center[1]);
            })

            this.map.fitBounds([
                [l, t],
                [r, b]
            ]);
        },
        createMap(width, height) {
            var bounds = [[0, 0], [height, width]];
            L.imageOverlay(this.image, bounds).addTo(this.map);
            this.map.setMaxBounds(bounds);
            this.map.fitBounds(bounds);

            this.map.on('click', (e) => {
                const p = e.latlng;
                this.updatePosition([Math.floor(p.lat), Math.floor(p.lng)]);
            })

            this.add();
        },
        updatePosition(pos) {
            this.center = pos;

            let position = {
                center: pos,
                height: parseInt(this.height),
                width: parseInt(this.width),
                radius: parseInt(this.radius),
                type: this.type,
                angle: this.value? this.value.position? this.value.position.angle? this.value.position.angle: 0: 0: 0
            };

            let tmp = this.item;
            tmp.position = position;

            this.item = tmp;

            this.add();
        },
        add() {
            if (this.rectangle) {
                this.rectangle.remove();
            }

            this.addRectangle(this.item);
        },
        // Function to rotate a point around a center
        rotatePoint(point, center, angle) {
            let x = center.lng + (point.lng - center.lng) * Math.cos(angle) - (point.lat - center.lat) * Math.sin(angle);
            let y = center.lat + (point.lng - center.lng) * Math.sin(angle) + (point.lat - center.lat) * Math.cos(angle);
            return L.latLng(y, x);
        },
        rotateRectangle(item,rectangle){
            if(!rectangle || !item.position){
                return;
            }
            let center = rectangle.getBounds().getCenter();
            let rotationRadians = (item.position.angle * Math.PI) / 180;
            let rotatedCorners = rectangle.getLatLngs()[0].map((corner) => {
                return this.rotatePoint(corner, center, rotationRadians);
            });

            rectangle.setLatLngs([rotatedCorners]);
        },
        addRectangle(item) {
            if (!item.position) {
                return;
            }

            if (item.position.type === 'circle') {
                this.rectangle = L.circle(item.position.center, {color: "red", radius: item.position.radius, weight: 1})
                    .addTo(this.map);

                return;
            }

            this.rectangle = L.rectangle([
                [item.position.center[0] + item.position.height, item.position.center[1] - item.position.width],
                [item.position.center[0] - item.position.height, item.position.center[1] + item.position.width],
            ], {color: "red", weight: 1})
                .addTo(this.map);

            this.rotateRectangle(item, this.rectangle);
        },
        rotateLeft(){
            this.value.position.angle += 10;
            this.updatePosition(this.center);
        },
        rotateRight(){
            this.value.position.angle -= 10;
            this.updatePosition(this.center);
        }
    }
}
</script>

<style scoped>

</style>